import {
  DELETE_ICON_TOP_OFFSET_LANDSCAPE,
  DELETE_ICON_TOP_OFFSET_PORTRAIT,
  TEXT_BOX_WIDTH_OFFSET_LANDSCAPE,
  TEXT_BOX_WIDTH_OFFSET_PORTRAIT,
} from '../../../constants/user-zone-textbox-offsets';

type GetTextAreaWidthProps = {
  cardFormat: string;
  cardFaceType: string;
  canvasWidth: number;
  canvasZoom: number;
  scalingFactor: number;
};

export const getDefaultUserTextPosition = ({
  cardFormat,
  cardFaceType,
  canvasWidth,
  canvasZoom,
  scalingFactor,
}: GetTextAreaWidthProps) => {
  // Getting the text area width
  const isLandscape = cardFormat === 'landscape';
  const isFrontOrBack = cardFaceType === 'front' || cardFaceType === 'back';
  const shouldUseWideText = isLandscape || isFrontOrBack;

  const padding = 40 * scalingFactor; // 20 * 2 * scalingFactor
  const totalPadding = 2 * padding;

  // For landscape cards,
  const width = shouldUseWideText
    ? canvasWidth / canvasZoom - totalPadding - TEXT_BOX_WIDTH_OFFSET_LANDSCAPE
    : canvasWidth / (2 * canvasZoom) - totalPadding - TEXT_BOX_WIDTH_OFFSET_PORTRAIT;
  const height = 100; // Default height
  // Getting top position
  const top = isLandscape ? DELETE_ICON_TOP_OFFSET_LANDSCAPE : DELETE_ICON_TOP_OFFSET_PORTRAIT;
  const left = isLandscape ? 65 : 52;

  return { width, height, top, left };
};
